import { env } from "@infra/implementations/config/env";

export const AppVersion = () => {
	return <div className="appVersion">{env.appVersion}</div>;
};
